export const JOBS = "/"
export const JOB_REDIRECT = "/jobs/:jobId"
export const JOB_SETS = "/job-sets"
export const V2_REDIRECT = "/v2"
export const OIDC_REDIRECT = "/oidc"

export const SETTINGS = "/settings"
export const SETTINGS_VISUAL_THEME = `${SETTINGS}/visual-theme`
export const SETTINGS_VALUE_DISPLAY = `${SETTINGS}/value-display`
export const SETTINGS_APPEARANCE = `${SETTINGS}/appearance`
export const SETTINGS_ACCOUNT = `${SETTINGS}/account`
export const SETTINGS_ABOUT = `${SETTINGS}/about`
